/* eslint-disable no-console */

import consumer from './consumer'

consumer.subscriptions.create('NotificationChannel', {
  connected() {
    // console.log('connected to notification channel')
  },

  disconnected() {
    // console.log('disconnected to notification channel')
  },

  received(data) {
    console.log({ data })

    if (data.type === 'recurrence_updated') {
      // Check if we're viewing this transport request and reload
      const currentPath = window.location.pathname
      const match = currentPath.match(/\/transport_requests\/(\d+)/)
      if (match && parseInt(match[1], 10) === data.transport_request_id) {
        window.location.reload()
      }
    }
  },
})
